export const articles = [
  {
    slug: 'allchinabuy-spreadsheet-complete-guide',
    key: 'spreadsheetGuide',
    descKey: 'spreadsheetGuideDesc',
    date: '2026-08-20',
    readTime: '8 min',
    category: 'Guide',
    image: 'https://readdy.ai/api/search-image?query=Organized%20spreadsheet%20with%20product%20data%20on%20modern%20laptop%20screen%2C%20soft%20natural%20light%2C%20clean%20minimal%20workspace%2C%20neutral%20tones%2C%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=article-1&orientation=landscape',
  },
  {
    slug: 'allchinabuy-review-2026',
    key: 'resourceReviews',
    descKey: 'reviewDesc',
    date: '2026-08-18',
    readTime: '6 min',
    category: 'Review',
    image: 'https://readdy.ai/api/search-image?query=Person%20reviewing%20products%20on%20tablet%20at%20modern%20desk%2C%20soft%20natural%20light%2C%20clean%20minimal%20interior%2C%20neutral%20tones%2C%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=article-2&orientation=landscape',
  },
  {
    slug: 'allchinabuy-shipping-cost-guide',
    key: 'resourceShipping',
    descKey: 'shippingCostDesc',
    date: '2026-08-15',
    readTime: '7 min',
    category: 'Shipping',
    image: 'https://readdy.ai/api/search-image?query=Shipping%20packages%20and%20delivery%20boxes%20on%20clean%20white%20surface%2C%20soft%20natural%20light%2C%20minimalist%20product%20photography%2C%20neutral%20tones%2C%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=article-3&orientation=landscape',
  },
  {
    slug: 'allchinabuy-coupon-discount-guide',
    key: 'resourceCoupons',
    descKey: 'couponDesc',
    date: '2026-08-12',
    readTime: '5 min',
    category: 'Coupons',
    image: 'https://readdy.ai/api/search-image?query=Discount%20coupon%20cards%20and%20promotional%20tags%20on%20light%20pastel%20background%2C%20soft%20natural%20light%2C%20clean%20editorial%20product%20photography%2C%20neutral%20tones%2C%20high%20detail&width=800&height=500&seq=article-4&orientation=landscape',
  },
  {
    slug: 'allchinabuy-warehouse-guide',
    key: 'resourceWarehouse',
    descKey: 'warehouseDesc',
    date: '2026-08-10',
    readTime: '6 min',
    category: 'Warehouse',
    image: 'https://readdy.ai/api/search-image?query=Modern%20warehouse%20interior%20with%20organized%20shelves%2C%20soft%20natural%20light%20from%20windows%2C%20clean%20minimal%20industrial%20aesthetic%2C%20neutral%20tones%2C%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=article-5&orientation=landscape',
  },
  {
    slug: 'allchinabuy-qc-quality-check',
    key: 'resourceQC',
    descKey: 'qcDesc',
    date: '2026-08-08',
    readTime: '7 min',
    category: 'QC',
    image: 'https://readdy.ai/api/search-image?query=Quality%20control%20inspection%20with%20magnifying%20glass%20and%20checklist%20on%20light%20desk%2C%20soft%20natural%20light%2C%20clean%20minimal%20workspace%2C%20neutral%20tones%2C%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=article-6&orientation=landscape',
  },
] as const;